/* A skill's markdown, rendered: the frontmatter as the YAML it is, then the body. */
import React from "react";

import CodeBlock from "@/shared/components/markdown/CodeBlock";
import Markdown from "@/shared/components/markdown/Markdown";

import { splitFrontmatter } from "../catalog";

export default function SkillMarkdown({ text }: { text: string }) {
  const { frontmatter, body } = splitFrontmatter(text);
  return (
    <div className="space-y-3 min-w-0">
      {frontmatter && <CodeBlock code={frontmatter} lang="yaml" title="Frontmatter" />}
      <Markdown text={body} />
    </div>
  );
}
